import { render, staticRenderFns } from "./AttentionMessageSection.vue?vue&type=template&id=3da22632&scoped=true"
import script from "./AttentionMessageSection.vue?vue&type=script&lang=ts"
export * from "./AttentionMessageSection.vue?vue&type=script&lang=ts"
import style0 from "./AttentionMessageSection.vue?vue&type=style&index=0&id=3da22632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da22632",
  null
  
)

export default component.exports